import React from "react";


function Professor(props){

  const imageStyle = {
    width: '100%',
}

  return(
    <div className="container">
      <div className="row my-3 col-md-9 col-lg-6">
        <div className="col-4">
          <img src={ require("../images/professor.gif") } style={imageStyle}/>
        </div>
        <div className="col-8">
        <br/>
        <p> <strong>Professor Oh Jong-Won</strong> </p>
        <p> <strong>Phone number:</strong> 02-362-7265</p>
        <p> <strong>Email: </strong>jwoh@yonsei.ac.kr</p>
        <p> <strong>Website: </strong> <a href="http://www.viromics.co.kr" target="_blank">viromics lab</a> </p>
       </div>
      </div>

      <div className="row my-3">
        <div className="col">
          <h2>Education</h2> <br/>
          <ol>
            <li> <strong>PHD: </strong> Department of Microbiology, University of Massachusetts Amherst, 1996</li> <br/>
            <li> <strong>Masters: </strong> Department of Food Engineering, College of Engineering, Yonsei University, 1986 </li> <br/>
            <li> <strong>Bachelor: </strong> Department of Food Engineering, College of Engineering, Yonsei University, 1984 </li> <br/>
          </ol>
          <h2>Experience</h2><br/>
          <ol>
            <li><strong>2009-Present:</strong>: Director, Biotechnology Industrialization Institute, Yonsei University</li> <br/>
            <li><strong>2000-Present:</strong>: Assistant Professor/Associate Professor/Professor, Department of Biotechnology</li> <br/>
            <li><strong>2008-2010</strong>: Chairman, Department of Biotechnology</li> <br/>
            <li><strong>2007-2008</strong>: Chairman, Life Science and Biotechnology, Underwood International College</li> <br/>
            <li><strong>1999-2000</strong>: Staff Research Associate, Department of Molecular Microbiology and Immunology, University of Southern California School of Medecine</li> <br/>
            <li><strong>1996-1999</strong>: Research Associate, Howard Hughes Medical Institute and Department of Molecular Microbiology and Immunology, University of Southern California School of Medicine</li> <br/>
            <li><strong>1987-1991</strong>: Research Associate, Cheiljedang Co., R&D Center, Molecular Biology Lab, Korea</li> <br/>
            <li><strong>1989</strong>:  Eugene Tech International, NJ, USA</li> <br/>
          </ol>
        </div>
      </div>

      <div className="row">
        <div className="col">
          <h2>Major Research Areas</h2><br/>
          <ol>
            <li> <strong>Regulation and control of RNA virus replication</strong> </li>
            <li> <strong> Virus-Host interactions</strong></li> <br/>
          </ol>
        </div>
      </div>

      <div className="col">
        <div className="col">
          <h2>Lectures</h2>
          <ol>
            <li>
              <strong>Undergraduate: 
              <ul>
                <li>General Microbiology</li>
                <li>Applied Microbiology</li>
              </ul> 
              </strong>
            </li> <br/>
            <li>
              <strong>Graduate School: 
              <ul>
                <li>단백질공학특론</li>
                <li>바이러스숙주상호작용</li>
              </ul> 
              </strong>
            </li> <br/>
          </ol>
        </div>
      </div>
    </div>
  );
  }

export default Professor;